import {useEffect, useState} from 'react'
import {BooksitoutServer} from '../../../../config/BooksitoutServer'
import TopPublishersResponse from '../responses/TopPublishersResponse'

const useTopPublishers = () => {
	const [data, setData] = useState<TopPublishersResponse | null>(null)
	const [isLoading, setIsLoading] = useState<boolean>(true)

	useEffect(() => {
		BooksitoutServer
			.get(`/v1/statistics/top-publishers`)
			.then(res => setData(res.data))
			.finally(() => setIsLoading(false))
	}, [])

	return [data, isLoading] as const
}

export default useTopPublishers
